const inlineMenu = document.querySelector(".header__inline-menu");
if (inlineMenu) {
	let items = inlineMenu.querySelectorAll("details");
	items.forEach(item => {
		item.addEventListener("mouseover", () => {
			item.setAttribute("open", true);
			const ul = item.querySelector("ul");
			if (ul) {
				ul.addEventListener("mouseleave", () => {
					item.removeAttribute("open");
				});
			}
			item.addEventListener("mouseleave", () => {
				item.removeAttribute("open");
			});
		});
	});
}
const collectionMenu = document.querySelectorAll('.oj-mega-menu__collection .mega-menu__link')
const collectionImage = document.querySelector('.header-menu__collection-image-container')
const images = document.querySelectorAll('.header-menu__collection-image-container img')
const collectionName = document.querySelectorAll('.oj-header__collection-menu-image-text')
collectionMenu.forEach(menu => {
	menu.addEventListener('mouseover', function () {
		collectionImage.dataset.collection = menu.innerHTML;
		let i = 0;
		images.forEach(img => {
			if (img.attributes[1].value == menu.innerText) {
				img.style.display = 'block'
				collectionName[i].style.display = 'block';
			} else {
				img.style.display = 'none'
				collectionName[i].style.display = 'none';
			}
			i = i + 1;
		});
	})
})
function announcementClose() {
	document.querySelector('.announcement-bar-section').style.display = "none";
}
document.addEventListener('click', function (event) {
	if (event.target.matches('.oj-header-drawer__collection-menu>summary')) {
		if (window.innerWidth < 990) {
			const collectionMenuItems = document.querySelectorAll('.menu-drawer__collection-menu .menu-drawer__menu-item');
			const collectionMenuImages = document.querySelectorAll('.header-drawer__collection-image-container .oj-header__collection-menu img');
			const drawerCollectionMenu = document.querySelectorAll('.oj-header-drawer__collection-menu-image-text')
			let currentItem = 0;
			function toggleSelection() {
				collectionMenuItems.forEach((item) => {
					item.classList.remove('selected');
				});
				drawerCollectionMenu[currentItem].parentNode.style.display = 'block';
				collectionMenuImages[currentItem].style.display = 'block';
				collectionMenuItems[currentItem].classList.add('selected');

				let i = 0;

				const selectedMenu = document.querySelectorAll('.menu-drawer__collection-menu .menu-drawer__menu-item.selected');
				const selectedMenuValue = selectedMenu[0].innerText.replace("\n", "").split(" ").join("");

				collectionMenuImages.forEach(img => {
					if (img.alt.split(" ").join("") == selectedMenuValue) {
						img.style.display = 'block';
						drawerCollectionMenu[i].style.display = 'none';
						drawerCollectionMenu[i].parentNode.style.display = 'block';
					} else {
						img.style.display = 'none'
						drawerCollectionMenu[i].style.display = 'none';
						drawerCollectionMenu[i].parentNode.style.display = 'none';
					}
					i = i + 1;
				});

				currentItem = (currentItem + 1) % collectionMenuItems.length;
			};

			toggleSelection();
			intervalId = setInterval(toggleSelection, 2000);
			document.querySelector('.oj-header-drawer__collection-menu .menu-drawer__close-button').addEventListener('click', function () {
				clearInterval(intervalId);
			});
		}
	}
})
